import { FC } from 'react';
import moment from 'moment';
import { letterTransform } from '../../helpers';
import { Item } from '../../services/generatedApi';

type PressCardProps = {
  item: Item;
  customClasses?: string;
};

const PressCard: FC<PressCardProps> = ({ item, customClasses }) => {
  const fallbackImage =
    '/Images/fallbacks/office1.jpg?mode=crop&quality=70&width=400&height=225';

  const toUrlSegment = (value: string | null | undefined) => {
    if (!value) return '';

    const transformedValue = letterTransform(value.toLowerCase());

    const urlString = transformedValue
      .replace(/"|"/g, '')
      .replace(/[^a-z0-9]/g, '-')
      .replace(/-+/g, '-');
    return urlString;
  };
  moment.locale('sv');

  return (
    <li
      className={`w-full h-full list-none ${
        customClasses ? customClasses : ''
      }`}
    >
      <a
        className="group block bg-white shadow-bs40 hover:shadow-bs60 rounded-md focus:outline focus:outline-2 focus:outline-blue-500 h-full overflow-hidden !transition-all textPressMessage"
        href={`/om-oss/press/pressmeddelanden/pressmeddelande/${toUrlSegment(
          item.title
        )}-${item?.id}/`}
        aria-label={`Läs pressmeddelande: ${item?.title}`}
      >
        {(() => {
          if (item?.mainImage && item?.mainImage?.thumbnail_16_9) {
            return (
              <img
                className="w-full h-auto"
                width="400"
                height="225"
                src={item?.mainImage?.thumbnail_16_9}
                loading="lazy"
                alt={item?.mainImage?.title ? item?.mainImage?.title : ''}
              />
            );
          }
          if (
            item?.images &&
            item?.images?.length > 0 &&
            item?.images[0].thumbnail_16_9
          ) {
            return (
              <img
                className="w-full h-auto"
                width="400"
                height="225"
                src={item?.images[0]?.thumbnail_16_9}
                alt={
                  item?.images[0].caption
                    ? item?.images[0].caption
                    : item?.images[0].title
                }
                loading="lazy"
              />
            );
          } else {
            return (
              <img
                className="w-full h-auto"
                width="400"
                height="225"
                src={fallbackImage}
                alt="Generisk bild för pressmeddelande"
                loading="lazy"
              />
            );
          }
        })()}
        <div className="bg-white p-4 py-4 rounded-b-md text-black700">
          <span className="text-grey400 text-tiny">
            {moment(item?.published).format('YYYY-MM-DD')}
          </span>
          {item?.title && (
            <h4 className="mt-1 mb-2 font-icb text-lg group-hover:underline line-clamp-3 text-pretty">
              {item?.title}
            </h4>
          )}
          {item?.leadTextOrBodyStrip && (
            <p className="mb-0 line-clamp-3">{item?.leadTextOrBodyStrip}</p>
          )}
        </div>
      </a>
    </li>
  );
};

export default PressCard;
